import { render, staticRenderFns } from "./Ceiling.vue?vue&type=template&id=05c04be8&"
import script from "./Ceiling.vue?vue&type=script&lang=js&"
export * from "./Ceiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports